angular.module("acl.visualizer.heatmap", [
  "acl.visualizer.charts.controllers",
  "acl.visualizer.charts",
  "acl.visualizer.color",
]);
